import React, { useState, useEffect } from "react";
import DropdownItem from "./DropdownItem";
import MegaDropdown from "./MegaDropdown";
import dataNav from "../../data/Navbar/navbar-data.json";
import useWindowResizeListener from "../../helpers/useWindowResizeListener";
import { MdOutlineKeyboardArrowDown, MdMenu, MdClose } from "react-icons/md";

const DropdownMenu = () => {
  useWindowResizeListener();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 991;

  // Toggle submenu only on desktop, no toggle on mobile
  const handleHover = (e) => {
    e.preventDefault();
    if (isMobile) return;

    const el = e.target;
    if (el.nextSibling) {
      if (el.parentElement.classList.contains("on")) {
        el.nextSibling.style.display = "none";
        el.parentElement.classList.remove("on");
        el.nextSibling.style.opacity = 0;
        el.nextSibling.classList.remove("fadeIn");
      } else {
        el.parentElement.classList.add("on");
        el.nextSibling.style.display = "block";
        el.nextSibling.style.opacity = 1;
        el.nextSibling.classList.add("fadeIn");
      }
    }
  };

  return (
    <div className="navbar-container">
      {/* Hamburger toggle aligned left */}
      <button
        className="navbar-toggler"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle navigation"
        style={{
          background: "none",
          border: "none",
          fontSize: "2rem",
          cursor: "pointer",
          float: "left",
          marginRight: "1rem",
          color: "inherit",
          paddingTop: "2rem",
          
        }}
      >
        {isMobileMenuOpen ? <MdClose /> : <MdMenu />}
      </button>

      <div
        className={`navbar-collapse ${isMobileMenuOpen ? "show" : "collapse"}`}
        id="navbar-menu"
        style={{ clear: "both" }}
      >
        <ul className="nav navbar-nav" data-in="fadeIn" data-out="fadeOut">
          {dataNav.map((dropdown, i) => {
            // Filter out subheaders on mobile
            const filteredSubMenu = isMobile
              ? dropdown.subMenu.filter((item) => !item.isHeader)
              : dropdown.subMenu;

            // Skip colsTitle on mobile by passing empty array
            const filteredColsTitle = isMobile ? [] : dropdown.colsTitle;

            return (
              <li
                className={
                  "dropdown nav-item " +
                  (dropdown.megaMenu === true ? "megamenu-fw" : "")
                }
                onClick={isMobile ? undefined : (e) => handleHover(e)}
                key={i}
              >
                <a className="dropdown-toggle nav-link" data-toggle="dropdown">
                  {dropdown.title}
                  {!isMobile && (
                    <MdOutlineKeyboardArrowDown className="red-color" />
                  )}
                </a>

                {dropdown.megaMenu ? (
                  <MegaDropdown
                    item={filteredSubMenu}
                    columnTitle={filteredColsTitle}
                    itemsPerCol={dropdown.itemsPerCol}
                  />
                ) : (
                  <DropdownItem item={filteredSubMenu} />
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default DropdownMenu;
